
import { useQuery } from '@tanstack/react-query';
import { InterviewService } from '@/services/interview/interviewService';
import { toast } from 'sonner';

export function useFeederInterviewsData() {
  const { data: feederInterviews, isLoading, error, refetch } = useQuery({
    queryKey: ['feederInterviews'],
    queryFn: async () => {
      const interviews = await InterviewService.getFeederInterviews();
      return interviews;
    },
    staleTime: 30000, // 30 seconds - data remains fresh for moderate time
    refetchInterval: false, // Disable auto refetching to prevent UI disruptions
    refetchOnWindowFocus: false, // Don't refetch on window focus to prevent blank screens
    meta: {
      onError: (error: Error) => {
        console.error('Error fetching feeder interviews:', error);
        toast.error(`Feil ved lasting av køintervjuer: ${error.message}`);
      },
    },
  });

  return {
    feederInterviews,
    isLoading,
    error,
    refetch
  };
}
